import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faMale, faChild, faArchive, faInfoCircle, faFileUpload,
  faCheckCircle, faMinusCircle, faCheck, faTimes,
  faEdit, faTrash, faBars, faSearch, faGlobe, faAngleDown,
} from '@fortawesome/free-solid-svg-icons';
import {
  faCheckCircle as rFaCheckCircle,
  faCalendarAlt as rFaCalendarAlt,
} from '@fortawesome/free-regular-svg-icons';
import {
  faFacebook,
  faTwitter,
  faWhatsapp,
  faInstagram,
  faYoutube,
  faVimeo,
} from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import vSelect from 'vue-select';
import MultiSelect from '@/components/UI/MultiSelect.vue';
import DatePicker from '@/components/UI/DatePicker.vue';
import SliderCheckbox from '@/components/UI/SliderCheckbox.vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/css/custom.scss';
import 'vue-select/dist/vue-select.css';

library.add(
  faFacebook,
  faTwitter,
  faWhatsapp,
  faInfoCircle,
  faFileUpload,
  faEdit,
  faTrash,
  faCheck,
  faTimes,
  faCheckCircle,
  faMinusCircle,
  faInstagram,
  faYoutube,
  faVimeo,
  faBars,
  faSearch,
  faGlobe,
  rFaCheckCircle,
  rFaCalendarAlt,
  faAngleDown,
);
library.add(faMale, faChild, faArchive);

Vue.component('fai', FontAwesomeIcon);
Vue.component('v-select', vSelect);
Vue.component('satmed-select', MultiSelect);
Vue.component('satmed-datepicker', DatePicker);
Vue.component('satmed-slider-checkbox', SliderCheckbox);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
